import randomstring from 'randomstring';

export const parseProps = (props) => {
  const properties = {};
  for (const prop in { ...props }) {
    if (props[prop] === true && prop !== 'disabled'
    ) {
      properties[prop] = 'true';
    } else if (props[prop] !== false) {
      properties[prop] = props[prop];
    }
  }

  return properties;
};

export const componentIdGenerator = () => randomstring.generate({
  length: 5,
  charset: 'alphabetic',
});

export const equalArrays = (arrayA, arrayB) => {
  if (arrayA.length === arrayB.length
    && arrayA.every((v, i) => v.text === arrayB[i].text)) {
    return true;
  }
  return false;
};
